import { getExpandingWildAction } from 'automaton/actions/ExpandingWildAction'
import { getWinBigAction } from 'automaton/actions/WinBigAction'
import { getWinMultiplyAction } from 'automaton/actions/WinMultiplyAction'
import { getWinSmallAction } from 'automaton/actions/WinSmallAction'
import { getFreespinAddState } from 'automaton/states/FreespinsAddState'
import { getFreespinEndState } from 'automaton/states/FreespinsEndState'
import { getFreespinsRespinState } from 'automaton/states/FreespinsRespinState'
import { getFreespinsSpinState } from 'automaton/states/FreespinsSpinState'
import { getSpreadState } from 'automaton/states/SpreadState'

import { delayAfterFS } from '../../settings/custom/freespins'
import { getFreespinEndDelayState } from './FreespinEndDelayState'

export function getFreespinsWinState() {
  const winModel = game.models.WinModel.get()
  const freespinModel = game.models.FreespinModel.get()
  const spinModel = game.models.SpinModel.get()

  const name = 'WIN'
  const actions = [
    getExpandingWildAction(),
    winModel.winType === 'regular'
      ? getWinSmallAction(false)
      : getWinBigAction(),
    getWinMultiplyAction(),
  ]
  const transition = () => spinModel.respin.length
    ? getFreespinsRespinState()
    : winModel.expendingMatrix.length
      ? getSpreadState()
      : freespinModel.left
        ? freespinModel.add
          ? getFreespinAddState(true)
          : getFreespinsSpinState()
        : delayAfterFS
          ? getFreespinEndDelayState()
          : getFreespinEndState()

  return {
    name,
    actions,
    transition,
  }
}
